import React from 'react';
import '../App.css'; // Импорт стилей

function ProfileCard() {
    return ( <
        div className = "profile-card" >
        <
        div className = "profile-info" >
        <
        h1 > YELAMAN JANIBEKOV < /h1> <
        h2 > FRONTEND DEVELOPER < /h2> <
        p > "My name is Yelaman, I am 21 years old, and I have recently completed my studies in Frontend Development. During my studies, I have been actively developing my web development skills, and currently have a good knowledge of technologies such as HTML5, CSS3, and JavaScript. I have also worked with modern technologies, such as React and Vue.js frameworks, adaptive interfaces, and interactive web applications.</p> <
        p > In addition to academic projects, I participated in educational Olympiads, which helped develop analytical thinking and skills
        for solving non - standard problems.My goal is to
        continue developing in web development and contribute to the creation of high - quality and convenient user interfaces. < /p> <
        p > I am attentive to detail, a quick learner and love to work in a team.In the near future, I strive to expand my knowledge and skills to become a more confident front - end specialist.
        "

        This story helps highlight your skills, experience and readiness
        for further development. < /p> <
        /div> <
        div className = "profile-image" >

        <
        /div> <
        /div>
    );
}

export default ProfileCard;